import {
    FiEdit2,
    FiDollarSign,
    FiClock,
    FiTarget,
    FiTrendingUp,
} from "react-icons/fi";
import { formatCurrency } from "../../utils/formatCurrency";

export default function MetaCard({ meta, onEdit, onAportar, onVerHistorial }) {
    const montoObjetivo = Number(meta.montoObjetivo ?? meta.monto_objetivo ?? 0);
    const montoActual = Number(meta.montoActual ?? meta.monto_actual ?? 0);

    const porcentaje =
        montoObjetivo > 0 ? (montoActual / montoObjetivo) * 100 : 0;

    return (
        <div className="card-panel">
            <h3 style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FiTarget size={20} />
                {meta.nombre}
            </h3>

            <p style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FiTrendingUp size={16} />
                <strong>Actual:</strong> {formatCurrency(montoActual)}
            </p>

            <p style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FiDollarSign size={16} />
                <strong>Objetivo:</strong> {formatCurrency(montoObjetivo)}
            </p>

            <div className="progress-bar-wrap">
                <div
                    className="progress-bar-fill"
                    style={{ width: `${Math.min(porcentaje, 100)}%` }}
                />
            </div>

            <p>{porcentaje.toFixed(1)}%</p>

            <div
                className="card-actions"
                style={{ display: "flex", gap: 8, flexWrap: "wrap" }}
            >
                <button
                    className="btn-secondary"
                    type="button"
                    onClick={() => onEdit(meta)}
                >
                    <FiEdit2 size={16} />
                    Editar
                </button>

                <button
                    className="btn-primary"
                    type="button"
                    onClick={() => onAportar(meta)}
                >
                    <FiDollarSign size={16} />
                    Registrar aporte
                </button>

                <button
                    className="btn-info"
                    type="button"
                    onClick={() => onVerHistorial(meta)}
                >
                    <FiClock size={16} />
                    Ver historial
                </button>
            </div>
        </div>
    );
}